<h2 class="active text-center">Preview</h2>
<div style="display: flex; justify-content: center; align-items: center;">
  <canvas #previewCanvas style="border: 1px solid #ddd; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"></canvas>
</div>